<template lang="pug">
  half-circle-spinner(
    :animation-duration="1000"
    :size="60"
    color="#1DA643"
  )
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'VPreloader',

  components: {
    HalfCircleSpinner
  }
}
</script>
